import { render, staticRenderFns } from "./VideoCallIncoming.vue?vue&type=template&id=fe244492&scoped=true&"
import script from "./VideoCallIncoming.vue?vue&type=script&lang=ts&"
export * from "./VideoCallIncoming.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallIncoming.vue?vue&type=style&index=0&id=fe244492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe244492",
  null
  
)

export default component.exports